<template>
  <div
    class="modal-mask artwork-modal bidding-increment-modal"
    @click="checkClickTarget"
    data-close-modal
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <slot name="header">
          <button
            class="bidding-increment-modal__close btn-oval btn-oval--transparent modal__close"
            data-close-modal
          >
            <span
              class="icon icon-close-big"
              data-close-modal
            />
          </button>
        </slot>
        <slot name="body">
          <div class="artwork artwork--modal">
            <div class="container artwork__thumbs_box">
              <div class="row">
                <ArtworkImage
                :imageSource="artwork.imageFullUrl"
                :artworkName="artwork.name"
                class="artwork__thumb_full col-md-12"
                />
              </div>
              <div v-if="artwork.attachedImages.length > 0" class="row artwork__thumb_row_attached">
                <template v-for="attached_image in artwork.attachedImages">
                  <ArtworkImage
                      :imageSource="attached_image.url"
                      :artworkName="artwork.name"
                      class="artwork__thumb_attached white-attached-container col-md-4 col-sm-6 col-6 artwork__image_attached"
                  />
                </template>
              </div>
            </div>
            <div class="artwork__details">
              <div class="row artwork__content">
                <div class="col-12 col-sm-auto">
                  <div class="headings--h2">
                    {{ artwork.catalogNumber }}
                  </div>
                </div>
                <ArtworkContent :artwork="artwork"/>
              </div>
            </div>
            <a class="carousel-control-prev" role="button" @click="previousModal()" >
              <span class="icon icon-arrow-left">
              </span>
            </a>
            <a class="carousel-control-next" role="button" @click="nextModal()">
              <span class="icon icon-arrow-right">
              </span>
            </a>
          </div>
          <div v-if="artwork.extraDescription" class="d-block artwork__extra-desc">
            <p class="text-muted" v-html="artwork.extraDescription"></p>
          </div>
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
import IsIos from '@/shared/mixins/is_ios';
import { mapGetters } from 'vuex';
import GlobalEvents from 'vue-global-events';
import { FIRST_PAGE } from './../../consts';
import ArtworkImage from '../artwork_image';
import ArtworkContent from './artwork_content';

export default {
  name: 'ArtworkModal',
  components: {
    ArtworkImage,
    ArtworkContent,
    GlobalEvents,
  },
  props: {
    artwork: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
  },
  mixins: [IsIos],
  computed: {
    ...mapGetters(['artworks']),
    page() {
      return this.$route.query.page || FIRST_PAGE;
    },
    searchParams() {
      return this.$route.query.q;
    },
  },
  methods: {
    checkClickTarget(event) {
      const clickedElementAttributes = event.target.attributes;

      Object.values(clickedElementAttributes).find((attribut) => {
        if (attribut.nodeName === 'data-close-modal') {
          this.closeModal();
        }
        return true;
      });
    },
    closeModal() {
      this.$router.push({
        name: 'finishedAuctionsCatalog',
        query: {
          page: this.page,
          q: this.searchParams,
          dzielo: undefined,
        },
      });
      if (this.isIos) {
        this.$scrollTo(`#artwork_${this.artwork.id}`, -1);
        document.body.classList.remove('ios-fix');
      } else {
        document.body.classList.remove('modal-open');
      }
    },
    bodyClass() {
      if (this.isIos) {
        document.body.classList.add('ios-fix');
      } else {
        document.body.classList.add('modal-open');
      }
    },
    nextModal() {
      if (this.isLastModal()) {
        this.switchToFirstModal();
      } else {
        this.$router.push({ name: 'finishedAuctionsCatalog', query: { dzielo: this.artworks[this.index + 1].slug, page: this.page, q: this.searchParams } });
      }
    },
    previousModal() {
      if (this.isFirstModal()) {
        this.switchToLastModal();
      } else {
        this.$router.push({ name: 'finishedAuctionsCatalog', query: { dzielo: this.artworks[this.index - 1].slug, page: this.page, q: this.searchParams } });
      }
    },
    switchToFirstModal() {
      this.$router.push({ name: 'finishedAuctionsCatalog', query: { dzielo: this.artworks[0].slug, page: this.page, q: this.searchParams } });
    },
    switchToLastModal() {
      this.$router.push({ name: 'finishedAuctionsCatalog', query: { dzielo: this.artworks[this.artworks.length - 1].slug, page: this.page, q: this.searchParams } });
    },
    isFirstModal() {
      return this.index === 0;
    },
    isLastModal() {
      return this.index === this.artworks.length - 1;
    },
  },
  mounted() {
    this.bodyClass();
  },
};
</script>



// WEBPACK FOOTER //
// app/javascript/packs/shared/components/modal/index.vue?4f490c42